import { AjaxService } from "../Helpers/AjaxService";
import {GrowerConsultant} from "../Models/Employee/GrowerConsultant";
import { RegionalManager } from "../Models/Employee/RegionalManager";
import { GlobalCacheKeys } from "../Helpers/LocalStorageCache";
export class ContactApi {
    private static instance: ContactApi;
    static getInstance() { return ContactApi.instance || (ContactApi.instance = new ContactApi())}

    getGrowerConsultant(): Promise<GrowerConsultant> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/employee/GetGrowerConsultant`;
        return new Promise<GrowerConsultant>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: GrowerConsultant) => {
                    resolve(result);
                },
                null,
                GlobalCacheKeys.User
            );
        });
    }
    getRegionalManager(): Promise<RegionalManager> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/employee/GetGrowerManager`;
        return new Promise<RegionalManager>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: RegionalManager) => {
                    resolve(result);
                },
                null,
                GlobalCacheKeys.User
            );
        });
    }

}